var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchableTable',{attrs:{"panel-header":'Kassen',"panel-route":'AddBalanceGroup',"show-search-bar":false,"table-data":_vm.balanceGroups,"table-meta-data":_vm.tableMetaData,"row-click":_vm.triggerView,"default-sort":['attributes.name', 'asc']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }